import React from "react";
import { styled } from "@mui/material/styles";
import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { GeneralTaskKeyValueListPairs } from "../../views/GeneralTask/generalTask.types";
import { PrettyJson } from "./PrettyJson";

const StyledTable = styled(Table)({
  tableLayout: "fixed",
  wordWrap: "break-word",
});

const StyledTableCell = styled(TableCell)({
  borderBottom: "none",
  verticalAlign: "top",
});

const AlternatingRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export interface KeyValueListTableProps {
  header: string | null;
  readonly data?: GeneralTaskKeyValueListPairs;
}

export const renderArrayAsString = (vals: readonly (string | null | undefined)[] | null | undefined) => {
  if (vals === null || vals === undefined) return "";
  if (vals.length === 1 && vals[0]) {
    return <PrettyJson json={vals[0]} />;
  } else {
    const val_list = vals.reduce((x, accum) => accum + ", " + x, "");
    return val_list ? val_list.slice(0, -2) : "";
  }
};

const KeyValueListTable: React.FC<KeyValueListTableProps> = ({ header, data }: KeyValueListTableProps) => {
  return (
    <Paper>
      <StyledTable stickyHeader size="small">
        {header && (
          <TableHead>
            <AlternatingRow>
              <StyledTableCell colSpan={2}>{header}</StyledTableCell>
            </AlternatingRow>
          </TableHead>
        )}
        <TableBody>
          {data?.map((kv) => (
            <AlternatingRow key={kv?.k}>
              <StyledTableCell>{kv?.k}</StyledTableCell>
              <StyledTableCell>{renderArrayAsString(kv?.v)}</StyledTableCell>
            </AlternatingRow>
          ))}
        </TableBody>
      </StyledTable>
    </Paper>
  );
};

export default KeyValueListTable;
